const SOURCES = [
  { name: "RemoteOK", logo: "https://www.google.com/s2/favicons?domain=remoteok.com&sz=64" },
  { name: "LinkedIn", logo: "https://www.google.com/s2/favicons?domain=linkedin.com&sz=64" },
  { name: "Indeed", logo: "https://www.google.com/s2/favicons?domain=indeed.com&sz=64" },
  { name: "Glassdoor", logo: "https://www.google.com/s2/favicons?domain=glassdoor.com&sz=64" },
  { name: "HackerNews", logo: "https://www.google.com/s2/favicons?domain=ycombinator.com&sz=64" },
  { name: "Wellfound", logo: "https://www.google.com/s2/favicons?domain=wellfound.com&sz=64" },
  { name: "Reddit", logo: "https://www.google.com/s2/favicons?domain=reddit.com&sz=64" },
  { name: "GitHub Jobs", logo: "https://www.google.com/s2/favicons?domain=github.com&sz=64" },
  { name: "Jobicy", logo: "https://www.google.com/s2/favicons?domain=jobicy.com&sz=64" },
  { name: "Crunchbase", logo: "https://www.google.com/s2/favicons?domain=crunchbase.com&sz=64" },
  { name: "We Work Remotely", logo: "https://www.google.com/s2/favicons?domain=weworkremotely.com&sz=64" },
  { name: "Arbeitnow", logo: "https://www.google.com/s2/favicons?domain=arbeitnow.com&sz=64" },
];

export function SourcesSection() {
  return (
    <section className="bg-zinc-50 border-b border-zinc-200">
      <div className="max-w-6xl mx-auto px-6 py-16">
        <div className="text-center mb-10">
          <h2
            className="text-2xl sm:text-3xl font-bold tracking-tight text-zinc-900"
            style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
          >
            We Search 12+ Job Sources For You
          </h2>
          <p className="text-zinc-600 mt-2">So you don't have to check them all yourself</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
          {SOURCES.map((source) => (
            <div
              key={source.name}
              className="bg-white border border-zinc-200 p-4 flex flex-col items-center gap-2 hover:border-[#002FA7]/30 hover:shadow-sm transition-all"
              data-testid={`source-${source.name.toLowerCase().replace(/\s/g, '-')}`}
            >
              <img
                src={source.logo}
                alt={source.name}
                className="w-8 h-8 object-contain"
                onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }}
              />
              <div className="w-8 h-8 bg-zinc-200 rounded items-center justify-center text-xs font-bold text-zinc-500 hidden">
                {source.name.charAt(0)}
              </div>
              <span className="text-xs font-medium text-zinc-700 text-center leading-tight">{source.name}</span>
            </div>
          ))}
        </div>

        <p className="text-center text-zinc-500 text-sm mt-6">
          We aggregate jobs from multiple sources, manually review them, and send you only the relevant ones.
        </p>
      </div>
    </section>
  );
}
